export default "__VITE_ASSET__CjircMAZ__"